import 'moment-timezone';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import React, { memo, useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { useMediaQuery } from 'react-responsive';
import { BadgeStatus, getEndpointUrl, getTimestamp } from "../../Utils/Common";

const DataTableInvoice = ({ onCallback }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const inputRef = useRef();
    const timeout = useRef();

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const [customers, setCustomers] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 0
    });

    const loadLazyData = () => {
        setLoading(true);

        fetch(getEndpointUrl() + `/invoice?page=${lazyParams.page}&per_page=${lazyParams.rows}&query=${globalFilterValue}&v=${getTimestamp()}`, { //
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
                // pragma: 'no-cache',
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setTotalRecords(json.results.total);
                setCustomers(json.results.data);
            }
            setLoading(false);
        });
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    useEffect(() => {
        return () => loadLazyData();
    }, [lazyParams]);

    useEffect(() => {
        //Clear the previous timeout.
        clearTimeout(timeout.current);

        // If there is no search term, do not make API call
        if (!globalFilterValue.trim()) {
            loadLazyData()
            return
        }
        timeout.current = setTimeout(() => {
            loadLazyData();
        }, 600);
    }, [globalFilterValue]);

    const onGlobalFilterChange = (e) => {
        setLoading(true);
        lazyParams.page = 0;
        setTotalRecords(0);
        setCustomers([]);

        const value = e.target.value;

        setGlobalFilterValue(value);
    };

    const header = (
        <Row>
            <Col md={12} className="my-2">
                <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText ref={inputRef} className="p-inputtext-lg" onChange={onGlobalFilterChange} placeholder="Pencarian..." style={{ minWidth: '100%' }} />
                </div>
            </Col>
        </Row>
    );

    const statusTemplate = (row) => <BadgeStatus status={row.invoiceStatus} />;

    const tglTemplate = (row) => <Moment format="DD/MM/YYYY">{row.invoiceDate}</Moment>;

    const tglTempoTemplate = (row) => <Moment format="DD/MM/YYYY">{row.doeDate}</Moment>;

    const priceTemplate = (row) => <NumericFormat
        value={row.amount}
        displayType={'text'}
        thousandSeparator={true}
        className="fw-medium"
        prefix={'Rp'}
        renderText={(value, props) => <span {...props}>{value}</span>} />;

    const mobileTemplate = (value) => {
        return <div className="mb-3">
            <div className="mt-2">
                <small className="text-muted">ID  <span className="fw-bold"> {value.id}</span></small><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>NAMA PELANGGAN</small><br />
                <span className="fw-bold">{value.customerName}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>NO HANDPHONE</small><br />
                <span className="fw-medium">{value.customerPhone}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>STATUS INVOICE</small><br />
                <BadgeStatus status={value.invoiceStatus} /><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>TGL INVOICE</small><br />
                <span className="fw-normal fst-italic"><Moment format="DD/MM/YYYY">{value.invoiceDate}</Moment></span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>TGL TEMPO</small><br />
                <span className="fw-normal fst-italic"><Moment format="DD/MM/YYYY">{value.doeDate}</Moment></span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>USER ENTRY</small><br />
                <span className="fw-normal">{value.usersName}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>TOTAL TAGIHAN</small><br />
                <span className="fw-normal">
                    <NumericFormat
                        value={value.amount}
                        displayType={'text'}
                        thousandSeparator={true}
                        className="fw-medium"
                        prefix={'Rp'}
                        renderText={(value, props) => <span {...props}>{value}</span>} />
                </span><br />
            </div>
        </div >;
    }

    return (
        <Container className="mt-3">
            <DataTable
                value={customers}
                lazy
                size="small"
                responsiveLayout="scroll"
                dataKey="id"
                header={header}
                globalFilterFields={['judul', 'deskripsi']}
                emptyMessage="Tidak ada data yang ditemukan."
                paginator
                first={lazyParams.first}
                rows={15}
                totalRecords={totalRecords}
                onPage={onPage}
                loading={loading}
                selectionMode="single"
                onSelectionChange={(e) => { onCallback(e.value) }}>
                {isTabletOrLaptop && <Column field="id" header="ID" />}
                {isTabletOrLaptop && <Column field="status" header="STATUS" body={statusTemplate} />}
                {isTabletOrLaptop && <Column field="customerName" header="NAMA PENAGIHAN" />}
                {isTabletOrLaptop && <Column field="customerPhone" header="NO HANDPHONE" />}
                {isTabletOrLaptop && <Column field="invoiceDate" header="TANGGAL" body={tglTemplate} />}
                {isTabletOrLaptop && <Column field="doeDate" header="TGL TEMPO" body={tglTempoTemplate} />}
                {isTabletOrLaptop && <Column field="usersName" header="USER ENTRY" />}
                {isTabletOrLaptop && <Column field="amount" header="JUMLAH TAGIHAN" body={priceTemplate} />}
                {isMobile && <Column body={mobileTemplate} />}
            </DataTable>
        </Container>
    );
}

export default memo(DataTableInvoice);
